import React from 'react';
import './Footer.css'

function Footer(props) {
	return <div className='footer'>API requested from: exchangerate.host</div>;
}

export default Footer;
